export const mainRoutesName = {
    root: 'root',
    dashboard: 'dashboard',
    home: 'home',
    newQuote: 'newQuote',
    quoteList: 'quoteList',
    settings: 'settings',
    userList: 'userList',
    companySettings: 'companySettings',
    accountSettings: 'accountSettings',
    mutateCompanyProfile: 'mutateCompanyProfile',
    addUser: 'addUser',
    mutateUser: 'mutateUser',
    manager: 'manager',
    companyList: 'companyList',
    productModelList: 'productModelList',
    pantoneList: 'pantoneList',
    optionalList: 'optionalList',
    measureList: 'measureList',
    measureGroupList: 'measureGroupList',
    registry: 'registry',
    mutateRegistry: 'mutateRegistry',
    mutateQuote: 'mutateQuote',
    createQuote: 'createQuote',
    viewQuote: 'viewQuote',
    accessoryList: 'accessoryList',
    mutateAccessory: 'mutateAccessory',
    priceList: 'priceList',
    mutatePrice: 'mutatePrice',
    quoteManage: 'quoteManage',

    superAdmin: 'superAdmin'
}

export const authRoutesName = {
    login: 'login',
    forgotPassword: 'forgotPassword',
    error: 'error',
    maintenance: 'maintenance',
    verifyEmail: 'verifyEmail',
    notAuthorized: 'notAuthorized',
    logout: 'logout',

}

export const routesName = {
    ...authRoutesName,
    ...mainRoutesName,
} as const;

export const initialPageRoute = routesName.dashboard;